import { Validators } from "@angular/forms";
import { FormControl } from "@angular/forms";

import { ICellRendererParams } from "@ag-grid-community/core";

import { Component, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { takeUntil } from "rxjs/operators";
import { RecieveByCaseComponent } from "src/app/modules/planyard/recieve-by-case/recieve-by-case.component";
import { Subject } from "rxjs";
import { ScanPoComponent } from "src/app/modules/planyard/scan-po/scan-po.component";
import { LoginModel } from "src/app/models/login.model";
import { PurchasingService } from "src/app/modules/planyard/purchasing.service";
import { HeaderService } from "src/app/components/header/header.service";

@Component({
  selector: "app-received-qty-cell-edit",
  templateUrl: "./received-qty-cell-edit.component.html",
  styleUrls: ["./received-qty-cell-edit.component.scss"],
})
export class ReceivedQtyCellEditComponent implements OnDestroy{
  buttonText: string = "";
  params;
  control: FormControl = new FormControl("", Validators.min(0));
  buttons = {
    all: "Receive all",
    none: "Received",
  };
  user:LoginModel;
  private destroy$ = new Subject<void>();
  outstanding: number;
  constructor(
    private dialog: MatDialog,
    private purchasingService :PurchasingService,
    public headerService:HeaderService
  ) {
    this.user = JSON.parse(localStorage.getItem("User")) as LoginModel;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.control.setValue(params.value);
    this.control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      if (value >= 0) {
        this.params.data.receivedQty = value;
        this.setButtonText();
      }
    });
    this.setButtonText();
  }

  addQty(qty) {
    if (this.headerService.useBinLocation) {
      this.dialog
        .open(ScanPoComponent, {
          width: "500px",
          data: {
            title: 'Scan',
            data: {
              poId: this.params.poId,
              warehouseId: this.purchasingService.warehouseId,
              qty: this.params.data.outstandingQty,
              items: this.params.data.itemName,
              isItem: true,
              itemId:this.params.data.purchaseOrderItemId
            }
          },
        })
        .afterClosed()
        .subscribe((e: any) => {
          if (e.refresh) {
            this.params.callbackFunction(true);
          }
        });
    }
    else {
      this.control.setValue(qty);
      this.setGrid(qty);
    }
  }

  setGrid(qty) {
    this.params.node.setDataValue("receivedQty", qty);
    this.params.callbackFunction();
  }

  valueChange(event): void {
   
    if (event.target.value >= 0) {
      this.setGrid(event.target.value);
    }
    if (!event.target.value) {
      this.setGrid(null);
    }
  }

  setButtonText(): void {
    this.outstanding = this.params.data.qty - +this.params.data.receivedQty;
    if (this.outstanding === 0) {
      this.buttonText = this.buttons.none;
    } else {
      this.buttonText = this.buttons.all;
    }
  }

  openDialog() {
    this.dialog
      .open(RecieveByCaseComponent, {
        width: "345px",
        data: {
          title: "Recieve by case",
          receivedQty: this.params.data.receivedQty,
          qtyPerCase: this.params.data.qtyPerCase 
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        if(response != undefined)
          this.params.node.setDataValue("receivedQty", response );
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
